<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>

    <!-- Department Section -->
    <ng-container *ngIf="data.access === 'department'">
        <div mat-dialog-content class="dialog-content text-muted">
            <form [formGroup]="departmentGroup" class="row">
                <mat-form-field class="col-12" appearance="outline">
                    <mat-label>Department</mat-label>

                    <!-- Display selected departments as chips -->
                    <mat-chip-list class="selected-chips">
                        <mat-chip *ngFor="let dept of selectedDepartments" [removable]="true"
                            (removed)="removeDepartment(dept)">
                            {{dept.name}}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip>
                    </mat-chip-list>

                    <!-- Searchable select dropdown -->
                    <mat-select (selectionChange)="onDepartmentChange($event)"
                        (openedChange)="onDropdownOpenChange($event, 'department')">
                        <mat-select-trigger>
                            <span *ngIf="selectedDepartments.length > 0">{{selectedDepartments.length}} selected</span>
                        </mat-select-trigger>
                        <mat-option class="search-option">
                            <input #deptSearchInput [(ngModel)]="departmentSearchText"
                                [ngModelOptions]="{standalone: true}" (ngModelChange)="filterDepartments()"
                                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                                placeholder="Search departments..." class="search-input">
                        </mat-option>
                        <mat-option *ngFor="let dept of filteredDepartments" [value]="dept.id">
                            {{dept.name}}
                        </mat-option>
                        <mat-option *ngIf="filteredDepartments.length === 0" disabled>
                            <em>No departments found</em>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
        <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
            <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
            <button mat-button class="btn btn-success yes-button" *ngIf="!isLoading; else loadingTemplate"
                cdkFocusInitial (click)="submit()"
                [disabled]="selectedDepartments.length === 0">{{data.confirmText}}</button>
            <ng-template #loadingTemplate>
                <button mat-button class="btn btn-danger yes-button" cdkFocusInitial disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </ng-template>
        </div>
    </ng-container>

    <!-- Branch Section -->
    <ng-container *ngIf="data.access === 'branch'">
        <div mat-dialog-content class="dialog-content text-muted">
            <form [formGroup]="departmentGroup" class="row">
                <mat-form-field class="col-12" appearance="outline">
                    <mat-label>Branch</mat-label>

                    <!-- Display selected branches as chips -->
                    <mat-chip-list class="selected-chips">
                        <mat-chip *ngFor="let branch of selectedBranches" [removable]="true"
                            (removed)="removeBranch(branch)">
                            {{branch.name}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>

                    <!-- Searchable select dropdown -->
                    <mat-select (selectionChange)="onBranchChange($event)"
                        (openedChange)="onDropdownOpenChange($event, 'branch')">
                        <mat-select-trigger>
                            <span *ngIf="selectedBranches.length > 0">{{selectedBranches.length}} selected</span>
                        </mat-select-trigger>
                        <mat-option class="search-option">
                            <input #branchSearchInput [(ngModel)]="branchSearchText"
                                [ngModelOptions]="{standalone: true}" (ngModelChange)="filterBranches()"
                                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                                placeholder="Search branches..." class="search-input">
                        </mat-option>
                        <mat-option *ngFor="let item of filteredBranches" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                        <mat-option *ngIf="filteredBranches.length === 0" disabled>
                            <em>No branches found</em>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
        <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
            <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
            <button mat-button class="btn btn-success yes-button" *ngIf="!isLoading; else loadingTemplate"
                cdkFocusInitial (click)="submitBranch()"
                [disabled]="selectedBranches.length === 0">{{data.confirmText}}</button>
            <ng-template #loadingTemplate>
                <button mat-button class="btn btn-danger yes-button" cdkFocusInitial disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </ng-template>
        </div>
    </ng-container>

    <!-- Client Section -->
    <ng-container *ngIf="data.access === 'client'">
        <div mat-dialog-content class="dialog-content text-muted">
            <form [formGroup]="departmentGroup" class="row">
                <mat-form-field class="col-12" appearance="outline">
                    <mat-label>Clients</mat-label>

                    <!-- Display selected clients as chips -->
                    <mat-chip-list class="selected-chips">
                        <mat-chip *ngFor="let client of selectedClients" [removable]="true"
                            (removed)="removeClient(client)">
                            {{client.name}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>

                    <!-- Searchable select dropdown -->
                    <mat-select (selectionChange)="onClientChange($event)"
                        (openedChange)="onDropdownOpenChange($event, 'client')">
                        <mat-select-trigger>
                            <span *ngIf="selectedClients.length > 0">{{selectedClients.length}} selected</span>
                        </mat-select-trigger>
                        <mat-option class="search-option">
                            <input #clientSearchInput [(ngModel)]="clientSearchText"
                                [ngModelOptions]="{standalone: true}" (ngModelChange)="filterClients()"
                                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                                placeholder="Search clients..." class="search-input">
                        </mat-option>
                        <mat-option *ngFor="let item of filteredClients" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                        <mat-option *ngIf="filteredClients.length === 0" disabled>
                            <em>No clients found</em>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
        <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
            <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
            <button mat-button class="btn btn-success yes-button" *ngIf="!isLoading; else loadingTemplate"
                cdkFocusInitial (click)="submitClient()"
                [disabled]="selectedClients.length === 0">{{data.confirmText}}</button>
            <ng-template #loadingTemplate>
                <button mat-button class="btn btn-danger yes-button" cdkFocusInitial disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </ng-template>
        </div>
    </ng-container>
</div>